import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0812854"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foot-container" }
const _hoisted_2 = { class: "foot-item" }
const _hoisted_3 = { class: "foot-item-content" }
const _hoisted_4 = { class: "foot-item" }
const _hoisted_5 = { class: "foot-item-content" }
const _hoisted_6 = { class: "foot-item" }
const _hoisted_7 = { class: "foot-item-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "foot-item-icp" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "foot-icp-text margin-top-5 margin-bottom-5" }, "版权所有 © 荧辉科技（三河）有限公司"),
  /*#__PURE__*/_createElementVNode("span", { class: "foot-icp-text margin-top-5 margin-bottom-5 margin-left-10" }, "冀ICP备2024093941号-1")
], -1))

import {AppConfig} from "@/config";
import FootQr from "@/views/foot/foot-qr.vue";
import FootNav from "@/views/foot/foot-nav.vue";
import FootContact from "@/views/foot/foot-contact.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { justify: "space-evenly" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          md: 9,
          span: _unref(AppConfig).all
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(FootQr)
              ])
            ])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 3,
          span: _unref(AppConfig).all,
          class: "hidden-md-and-down"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(FootNav)
              ])
            ])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 6,
          span: _unref(AppConfig).all
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(FootContact)
              ])
            ])
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _hoisted_8
  ]))
}
}

})